/* session/sagas */
import { all, fork, put, takeEvery, select } from "redux-saga/effects";
import { SessionActionTypes } from "./types";
import { logout } from "../../repo/session";
import {
  fetchSuccess,
  logoutRequest,
  logoutSuccess,
  logoutError,
} from "./actions";
import { configureWithSessionState } from "../../repo/api";
import { ApplicationState } from "../index";

const getSession = (state: ApplicationState) => state.session;

function* watchDirtyRequest() {
  yield takeEvery(SessionActionTypes.DIRTY, () => {
    configureWithSessionState({
      data: null,
      loading: false,
      dirty: false,
      second: undefined,
    });
    // Note: Auth0 logout should be handled in the component, not in saga
  });
}

function* watchClearStorageRequest() {
  yield takeEvery(SessionActionTypes.CLEAR_STORAGE, () => {
    sessionStorage.clear();
  });
}
function* handleSetSession(action: ReturnType<any>) {
  yield put(fetchSuccess(action.payload));
  configureWithSessionState(yield select(getSession));
}

function* watchSetSession() {
  yield takeEvery(SessionActionTypes.SET_SESSION, handleSetSession);
}

function* handleLogout(action: ReturnType<typeof logoutRequest>) {
  try {
    // Call the logout API to blacklist the token using the repo pattern
    const response = yield logout();
    
    // If successful, dispatch success action
    yield put(logoutSuccess());
    
    // Clear session storage
    sessionStorage.clear();
    
    // Clear session state
    configureWithSessionState({
      data: null,
      loading: false,
      dirty: false,
      second: undefined,
    });
    
    // Call success callback if provided
    yield action.payload.callback && action.payload.callback(null, true);
    
  } catch (error: any) {
    const errorMessage = error.message || 'Network error during logout';
    yield put(logoutError(errorMessage));
    yield action.payload.callback && action.payload.callback(errorMessage, false);
  }
}

function* watchLogoutRequest() {
  yield takeEvery(SessionActionTypes.LOGOUT_REQUEST, handleLogout);
}

export default function* sessionSaga() {
  yield all([
    // fork(watchFetchRequest),
    fork(watchDirtyRequest),
    fork(watchClearStorageRequest),
    fork(watchSetSession),
    fork(watchLogoutRequest),
  ]);
}
